<template>
<div class="upload-container">
    <el-button  icon="el-icon-upload" size="mini" type="primary" @click="open">上传视频
    </el-button>
    <el-dialog :visible.sync="dialogVisible" :append-to-body='true'>
      <el-upload
        v-loading="loading"
        :action="qiniu.actionPath"
        :data="qiniu.postData"
        class="video-uploader"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
      >
      <video v-if="urls" controls :src="urls" class="editorVideoAvatar"></video>
       <!-- <el-button size="small" type="primary">点击上传</el-button> -->
      <i v-else class="el-icon-plus video-uploader-icon"></i>
    </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { getQiniuToken } from "@/api/common";
import { guid } from "@/utils/index";

export default {
  name: "UploadOne",
  props: {
    url: {
      value: ""
    },
    width: {
      type: String,
      default: "120px"
    },
    height: {
      type: String,
      default: "120px"
    }
  },
  model: {
    prop: "url", //绑定的值，通过父组件传递
    event: "update" //自定义时间名
  },
  data() {
    return {
      loading: false,
      qiniu: {
        actionPath: "",
        baseUrl: "",
        postData: {}
      },
      dialogVisible:false,
      urls:'',
    };
  },
  created() {
    getQiniuToken().then(response => {
      // token可多次使用
      this.qiniu.actionPath = response.data.uploadUrl;
      this.qiniu.baseUrl = response.data.baseUrl;
      if (!this.qiniu.postData.token) {
        this.qiniu.postData.token = response.data.token;
      }
    });
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.urls = ''
    },
    beforeUpload(file) {
      // 上传前需生成图片的GUID唯一名
      let type = ['mp4','rmvb','wmv','avi','mov','flv',]
      if(type.indexOf(file.type.split('/')[1]) == -1) {
        this.$message({
          type: "error",
          message: `请上传正确的视频`
        });
        return
      }
      this.qiniu.postData.key = guid() + '.' + file.type.split('/')[1];
      this.loading = true;
    },
    uploadSuccess(res) {
      let url = this.qiniu.baseUrl + "/" + res.key;
      this.urls = url
      this.$emit("update", url); //子组件与父组件通讯，告知父组件更新绑定的值
      this.loading = false;
    },
    handleSubmit() {
      if(!this.urls) {
        this.$message({
          type: "error",
          message: `请上传视频`
        });
        return
      }
      this.dialogVisible = false
      this.$emit("videosSuccessCBK", this.urls); //子组件与父组件通讯，告知父组件更新绑定的值
    },
    uploadError(res) {
      this.loading = false;
      this.$message({
        type: "error",
        message: `操作失败,${res}`
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 200px;
  height: 200px;
  margin-bottom:5px;
  .video-uploader-icon {
    color: #8c939d;
    width: 200px;
    height: 200px;
    margin-top:93px;
    
  }
  .editorVideoAvatar {
    width: 200px;
    height: 200px;
    display: block;
  }
}
.video-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
